export const mens_kurta=[
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/l5h2xe80/kurta/x/6/n/xl-kast-tile-green-majestic-man-original-imagg4z33hu4kzpv.jpeg?q=70",
        "brand": "Majestic Man",
        "title": "Men Printed Pure Cotton Straight Kurta",
        "color": "Green",
        "discountedPrice": 499,
        "price": 1499,
        "discountPersent": 66,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/l/f/r/xl-k-spl668-yellow-sg-leman-original-imagznqcrahgq9rf.jpeg?q=70",
        "brand": "SG LEMAN",
        "title": "Men Embroidered Jacquard Straight Kurta",
        "color": "Yellow",
        "discountedPrice": 799,
        "price": 2499,
        "discountPersent": 68,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/g/6/k/m-sksh-dt1105-pcbl-fubar-original-imafux247zhqym2z-bb.jpeg?q=70",
        "brand": "FUBAR",
        "title": "Men Printed Cotton Blend Straight Kurta",
        "color": "Blue",
        "discountedPrice": 399,
        "price": 1499,
        "discountPersent": 73,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/i/v/x/xxl-br-ad-kt-105-adwyn-peter-original-imagj4zyd2q7t6cg.jpeg?q=70",
        "brand": "ALY JOHN",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "White",
        "discountedPrice": 474,
        "price": 1999,
        "discountPersent": 76,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/j/a/r/l-poch521835-peter-england-original-imag7jg47g7cxhg3-bb.jpeg?q=70",
        "brand": "PETER ENGLAND",
        "title": "Men Woven Design Pure Cotton Straight Kurta",
        "color": "Grey",
        "discountedPrice": 524,
        "price": 1049,
        "discountPersent": 50,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/y/c/x/xl-kast107hp-majestic-man-original-imafw49u5uty4agx-bb.jpeg?q=70",
        "brand": "Majestic Man",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "Pink",
        "discountedPrice": 499,
        "price": 1499,
        "discountPersent": 66,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/kpodocw0/t-shirt/x/o/4/xl-wr-64-wrodss-original-imag3upwgq9n9fbv.jpeg?q=70",
        "brand": "WRODSS",
        "title": "Men Solid Cotton Blend Straight Kurta",
        "color": "Black",
        "discountedPrice": 277,
        "price": 999,
        "discountPersent": 72,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/l4zxn680/kurta/i/g/u/s-mtml0039-341-manthan-original-imagfrz3gwgdtczm.jpeg?q=70",
        "brand": "Manthan",
        "title": "Men Printed Cotton Blend Straight Kurta",
        "color": "Blue",
        "discountedPrice": 765,
        "price": 1049,
        "discountPersent": 27,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/m/e/e/s-kurta-rahul-look-original-imaga2g6qmhbywdf-bb.jpeg?q=70",
        "brand": "RAHUL LOOK",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "Green",
        "discountedPrice": 499,
        "price": 1599,
        "discountPersent": 68,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/u/v/m/l-grey-106-yellow-freluro-original-imagc26vdpwxgztu-bb.jpeg?q=70",
        "brand": "FRELURO",
        "title": "Men Printed Cotton Blend Straight Kurta",
        "color": "Yellow",
        "discountedPrice": 429,
        "price": 999,        
        "discountPersent": 57,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/jsj90280/kurta/j/z/g/l-mtmkos0004-326-manthan-original-imafe35wha5ry36p.jpeg?q=70",
        "brand": "Manthan",
        "title": "Men Self Design Cotton Blend Straight Kurta",
        "color": "Light Blue",
        "discountedPrice": 729,
        "price": 909,        
        "discountPersent": 27,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/g/f/f/xl-grey-sws4503-allan-peter-original-imag6xxgvvh59gh5-bb.jpeg?q=70",
        "brand": "allan peter",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "Green",
        "discountedPrice": 449,
        "price": 1749,
        "discountPersent": 74,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/u/g/z/xl-8button-kurta-elepants-original-imagk57kfg2bwvhd.jpeg?q=70",
        "brand": "COMBRAIDED",
        "title": "Men Solid Cotton Blend Straight Kurta",
        "color": "Dark Blue",
        "discountedPrice": 449,
        "price": 1499,
        "discountPersent": 70,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/7/b/q/xl-short-button-yellow-101-deal4mens-original-imagf6nzhwufyygg.jpeg?q=70",
        "brand": "FOLGEN",
        "title": "Men Solid Cotton Blend Straight Kurta",
        "color": "Yellow",
        "discountedPrice": 385,
        "price": 1299,
        "discountPersent": 70,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/l3lx8cw0/kurta/d/o/m/l-kurta-mr-button-tap-in-original-imagezztuysgufsh.jpeg?q=70",
        "brand": "Tap in",
        "title": "Men Solid Cotton Blend Straight Kurta",
        "color": "Orange",
        "discountedPrice": 395,
        "price": 1495,
        "discountPersent": 73,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/a/m/4/xl-sksh-dt1105-navy-fubar-original-imafuyzzh7fx6kaw-bb.jpeg?q=70",
        "brand": "FUBAR",
        "title": "Men Printed Cotton Blend Straight Kurta",
        "color": "Dark Blue",
        "discountedPrice": 399,
        "price": 1648,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/7/m/3/xxl-vlsd-a0ltpk-vida-loca-original-imagk5ggvxf97dwz.jpeg?q=70",
        "brand": "Vida Loca",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "White",
        "discountedPrice": 599,
        "price": 2499,
        "discountPersent": 76,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/kxkqavk0/kurta/l/w/t/xxl-vlsd-a0lt-vida-loca-original-imagay8hcrqax2uv.jpeg?q=70",
        "brand": "Vida Loca",
        "title": "Men Self Design Pure Cotton Straight Kurta",
        "color": "White",
        "discountedPrice": 629,
        "price": 2499,
        "discountPersent": 74,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/n/p/q/xxl-white-kurta-lilen-spoque-original-imagnk2zzcgqst3r.jpeg?q=70",
        "brand": "Nofilter",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "White",
        "discountedPrice": 370,
        "price": 1499,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/l/9/r/xxl-ksh-p-kurta-yellow-ksh-trendz-original-imafyq4h7q5gpkzk-bb.jpeg?q=70",
        "brand": "KSH Trendz",
        "title": "Men Solid Cotton Blend Straight Kurta",
        "color": "Yellow",
        "discountedPrice": 363,
        "price": 1499,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/kxkqavk0/kurta/c/p/f/xxl-vlsd-a0lt-vida-loca-original-imagay8hjdc9cdzh.jpeg?q=70",
        "brand": "Vida Loca",
        "title": "Men Self Design Pure Cotton Straight Kurta",
        "color": "Beige",
        "discountedPrice": 629,
        "price": 2499,
        "discountPersent": 74,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/5/w/o/l-vlsd-a0lt-vida-loca-original-imagay8hg3nydjuh-bb.jpeg?q=70",
        "brand": "Vida Loca",
        "title": "Men Self Design Pure Cotton Straight Kurta",
        "color": "Light Blue",
        "discountedPrice": 629,
        "price": 2499,
        "discountPersent": 74,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/v/7/w/xl-sksh-dt1105-pur-fubar-original-imafuy3z57uqgdrp-bb.jpeg?q=70",
        "brand": "FUBAR",
        "title": "Men Printed Cotton Blend Straight Kurta",
        "color": "Purple",
        "discountedPrice": 399,
        "price": 1648,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/kfpq5jk0-0/kurta/e/g/i/m-kast109pp-majestic-man-original-imafw49u8vyzygpn.jpeg?q=70",
        "brand": "Majestic Man",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "Pink",
        "discountedPrice": 499,
        "price": 1499,
        "discountPersent": 66,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/y/r/m/xxs-sada-plain-kurta-ksh-trendz-original-imag4baggdt7txju-bb.jpeg?q=70",
        "brand": "KSH Trendz",
        "title": "Men Solid Cotton Blend Straight Kurta",
        "color": "Yellow",
        "discountedPrice": 265,
        "price": 1499,
        "discountPersent": 82,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/t/g/w/xxl-ae08sk42-blue-aew-designs-original-imagg8npatfky9wg.jpeg?q=70",
        "brand": "ARMAAN ETHNIC",
        "title": "Men Self Design Cotton Blend Straight Kurta",
        "color": "Blue",
        "discountedPrice": 483,
        "price": 1999,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/b/0/5/m-kast-fern-lit-green-majestic-man-original-imagzrafzhtbnz7s.jpeg?q=70",
        "brand": "Majestic Man",
        "title": "Men Printed Pure Cotton Straight Kurta",
        "color": "Light Green",
        "discountedPrice": 499,
        "price": 1499,
        "discountPersent": 66,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/e/o/4/m-kast-hukum-orange-majestic-man-original-imagzra2fzadkyrz.jpeg?q=70",
        "brand": "Majestic Man",
        "title": "Men Printed Pure Cotton Straight Kurta",
        "color": "Orange",
        "discountedPrice": 499,
        "price": 1499,
        "discountPersent": 66,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/s/p/a/l-kcsh-krt-103-mao-fubar-original-imag7fpesvngbwyy-bb.jpeg?q=70",
        "brand": "FUBAR",
        "title": "Men Printed Cotton Blend Straight Kurta",
        "color": "Maroon",
        "discountedPrice": 399,
        "price": 1648,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/8/u/r/xl-sws2701-allan-peter-original-imafvxcfcsg4dzab-bb.jpeg?q=70",
        "brand": "allan peter",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "Pink",
        "discountedPrice": 449,
        "price": 1749,
        "discountPersent": 74,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/x/u/y/s-smpl04-deemoon-original-imagk5mnr9ufeha2.jpeg?q=70",
        "brand": "DEEMOON",
        "title": "Men Floral Print Cotton Blend Straight Kurta",
        "color": "Dark Blue",
        "discountedPrice": 468,
        "price": 1599,
        "discountPersent": 70,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/z/l/b/xl-grey-sws2902-allan-peter-original-imag3y6tzaaxwkhy-bb.jpeg?q=70",
        "brand": "allan peter",
        "title": "Men Printed Pure Cotton Straight Kurta",
        "color": "Dark Blue",
        "discountedPrice": 499,
        "price": 1749,
        "discountPersent": 71,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/e/j/j/l-jcardkurta-yellow-divra-clothing-original-imaggjhfgjqhuwtk.jpeg?q=70",
        "brand": "More & More",
        "title": "Men Self Design Cotton Blend Straight Kurta",
        "color": "Yellow",
        "discountedPrice": 467,
        "price": 2199,
        "discountPersent": 78,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/o/u/d/s-up-kurta-31035-phone-sg-leman-original-imagzu7tgzgtmnvb.jpeg?q=70",
        "brand": "SG LEMAN",
        "title": "Men Printed Pure Silk Straight Kurta",
        "color": "Gold",
        "discountedPrice": 810,
        "price": 2499,
        "discountPersent": 67,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/kybvo280/kurta/v/i/i/xxl-aly2502-aly-john-original-imagah6me94dugrs.jpeg?q=70",
        "brand": "ALY JOHN",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "Maroon",
        "discountedPrice": 478,
        "price": 1279,
        "discountPersent": 62,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/6/y/v/m-sksh-dt1105-black-fubar-original-imag4cpwzmhbufg4-bb.jpeg?q=70",
        "brand": "FUBAR",
        "title": "Men Striped Cotton Blend Straight Kurta",
        "color": "Black",
        "discountedPrice": 399,
        "price": 1648,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/l3khsi80/kurta/1/c/6/l-mtml0042-328-manthan-original-imagenvzkm3v9vxh.jpeg?q=70",
        "brand": "Manthan",
        "title": "Men Printed Cotton Blend Ethnic Dress",
        "color": "Orange",
        "discountedPrice": 948,
        "price": 1299,
        "discountPersent": 27,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/s/w/c/xl-vlmk-combzip02-vida-loca-original-imagkc4hhm4fxhjb.jpeg?q=70",
        "brand": "Vida Loca",
        "title": "Pack of 2 Men Solid Pure Cotton Straight Kurta",
        "color": "Multicolor",
        "discountedPrice": 994,
        "price": 2499,
        "discountPersent": 60,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/t/j/u/s-pink-kurta-lilen-spoque-original-imagnfkwk5gpfmzx.jpeg?q=70",
        "brand": "SPOQUE",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "Pink",
        "discountedPrice": 362,
        "price": 1499,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    },
    {
        "imageUrl": "https://rukminim1.flixcart.com/image/612/612/xif0q/kurta/x/f/6/xxl-new-white-nofilter-original-imaghzggudfezpr8.jpeg?q=70",
        "brand": "Nofilter",
        "title": "Men Solid Pure Cotton Straight Kurta",
        "color": "White",
        "discountedPrice": 393,
        "price": 1599,
        "discountPersent": 75,
        "size": [
            {
              "name": "S",
              "quantity": 20
            },
            {
              "name": "M",
              "quantity": 30
            },
            {
              "name": "L",
              "quantity": 50
            }
          ],
          "quantity": 100,
          "topLavelCategory": "Men",
          "secondLavelCategory": "Clothing",
          "thirdLavelCategory": "mens_kurta",
          "description":"A traditional garment embodying elegance and grace. Crafted from fine fabrics, it features intricate embroidery and a relaxed fit, providing comfort and style."
    }
]